type RoadmapLoadStateArgs = {
  facetsLoading: boolean;
  facetsError: Error | null;
  datasetRequired: boolean;
  hasDataset: boolean;
  datasetLoading: boolean;
  datasetError: Error | null;
};

const ROADMAP_SNAPSHOT_UNAVAILABLE_ERROR_PATTERN =
  /^Failed to load roadmap data \(404\):.*\bsnapshot\b/i;

export const isRoadmapSnapshotUnavailableError = (error: unknown): boolean =>
  error instanceof Error && ROADMAP_SNAPSHOT_UNAVAILABLE_ERROR_PATTERN.test(error.message);

export const getRoadmapLoadState = ({
  facetsLoading,
  facetsError,
  datasetRequired,
  hasDataset,
  datasetLoading,
  datasetError,
}: RoadmapLoadStateArgs) => {
  const missingRequiredDataset = datasetRequired && !hasDataset;

  return {
    shellLoading: facetsLoading,
    shellError: facetsError,
    contentLoading: missingRequiredDataset && datasetLoading,
    contentError:
      missingRequiredDataset && !datasetLoading
        ? (datasetError ?? new Error("Couldn't load the roadmap."))
        : null,
  };
};
